module.exports = __webpack_public_path__ + "media/images/brands/marque-shellac@2x-9a61c499c9a03c00bfa1add0a10b4e3b.jpg";